import { useMantineColorScheme } from '@mantine/core';

// Shared semantic colors for onboarding component inline styles, mirroring onboardingStyles.
// Lets the step components and guided-setup modal adapt to dark mode.
export function useOnbColors() {
  const { colorScheme } = useMantineColorScheme();
  const dark = colorScheme === 'dark';
  return {
    dark,
    pageBg: dark ? '#0B0C0F' : '#FFFFFF',
    card: dark ? '#16181D' : '#FFFFFF',
    surface: dark ? '#1B1E25' : '#F9FAFB',
    surface2: dark ? '#1B1E25' : '#FAFAFA',
    border: dark ? '#2A2E37' : '#EAEAEA',
    border2: dark ? '#2A2E37' : '#E5E7EB',
    textTitle: dark ? '#F8FAFC' : '#0A0A0A',
    textPrimary: dark ? '#F3F4F6' : '#111827',
    textSecondary: dark ? '#B8BDC7' : '#4B5563',
    text3: dark ? '#C4C9D2' : '#374151',
    textGray: dark ? '#9BA1AC' : '#6B7280',
    textMuted: dark ? '#8A909B' : '#9CA3AF',
    // accents (kept vivid; backgrounds tinted dark)
    purple: dark ? '#A78BFA' : '#6D28D9',
    purpleText: dark ? '#C4B5FD' : '#7C3AED',
    purpleDeep: dark ? '#C4B5FD' : '#5B21B6',
    purpleBg: dark ? '#231B34' : '#F6F4FF',
    purpleBg2: dark ? '#201830' : '#F5F3FF',
    purpleBorder: dark ? '#3B2E5C' : '#E9D5FF',
    blue: dark ? '#93C5FD' : '#1D4ED8',
    blueDeep: dark ? '#BFDBFE' : '#1E3A8A',
    blueText: dark ? '#93C5FD' : '#1E40AF',
    blueBg: dark ? '#12233F' : '#EFF6FF',
    blueBorder: dark ? '#1E3A5F' : '#BFDBFE',
    green: dark ? '#34D399' : '#059669',
    greenDeep: dark ? '#6EE7B7' : '#065F46',
    greenText: dark ? '#A7F3D0' : '#047857',
    greenBg: dark ? '#0F241C' : '#ECFDF5',
    greenBorder: dark ? '#14532D' : '#A7F3D0',
    amber: dark ? '#FCD34D' : '#B45309',
    amberText: dark ? '#FCD34D' : '#92400E',
    amberBg: dark ? '#2A2410' : '#FFFBEB',
    amberBg2: dark ? '#2A2410' : '#FFF7ED',
    amberBorder: dark ? '#4D3B12' : '#FDE68A',
    amberBorder2: dark ? '#4D3B12' : '#FED7AA',
    red: dark ? '#FCA5A5' : '#B91C1C',
    redDeep: dark ? '#FCA5A5' : '#991B1B',
    redText: dark ? '#F87171' : '#9A3412',
    redBg: dark ? '#2A1414' : '#FEF2F2',
    redBorder: dark ? '#5C1E1E' : '#FECACA',
    inputReadonlyBg: dark ? '#15181E' : '#F9FAFB',
  };
}
